import { Component } from '@angular/core';

@Component({
  selector: 'empathy-carousel-rating-description',
  templateUrl: 'carousel-rating-description.component.html',
  styleUrls: ['./carousel-rating-description.component.scss']
})
export class CarouselRatingDescriptionComponent {}
